module.exports = __webpack_public_path__ + "img/UT0387.63b51ac9.png";